const YARD_CONTACT_FIELDS = [
    'contactPerson',
    'contactEmail',
    'contactNumber',
    'contactPersonExtension'
];

const toArray = (value) => {
    if (Array.isArray(value)) {
        return value;
    }
    return value ? [value] : [];
};

export const normalizeYardContactValue = (value) => {
    if (value == null) {
        return '';
    }
    return String(value).trim();
};

export const getYardContactRows = (yardDetails = {}) => {
    const contactPeople = toArray(yardDetails.contactPerson);
    const contactEmails = toArray(yardDetails.email);
    const contactNumbers = toArray(yardDetails.contactNumbers);
    const contactExtensions = toArray(yardDetails.contactPersonExtension);
    const maxRows = Math.max(
        contactPeople.length,
        contactEmails.length,
        contactNumbers.length,
        contactExtensions.length
    );

    return Array.from({ length: maxRows }, (_, index) => ({
        contactPerson: normalizeYardContactValue(contactPeople[index]),
        contactEmail: normalizeYardContactValue(contactEmails[index]),
        contactNumber: normalizeYardContactValue(contactNumbers[index]),
        contactPersonExtension: normalizeYardContactValue(contactExtensions[index])
    })).filter((row) => YARD_CONTACT_FIELDS.some((field) => row[field]));
};

export const getDefaultYardContactDraft = (yardDetails = {}) => (
    getYardContactRows(yardDetails)[0] || {
        contactPerson: '',
        contactEmail: '',
        contactNumber: '',
        contactPersonExtension: ''
    }
);

export const buildYardContactDraft = (yardData = {}, yardDetails = {}) => {
    return {
        contactPerson: normalizeYardContactValue(yardData.contactPerson),
        contactEmail: normalizeYardContactValue(yardData.contactEmail),
        contactNumber: normalizeYardContactValue(yardData.contactNumber),
        contactPersonExtension: normalizeYardContactValue(yardData.contactPersonExtension)
    };
};

export const getAssignmentOrPrimaryYardValue = (assignmentValue, primaryValue) => {
    return normalizeYardContactValue(assignmentValue) || normalizeYardContactValue(toArray(primaryValue)[0]);
};

export const getYardContactAutocompleteOptions = (contactRows = [], field) => {
    const seenValues = new Set();

    return contactRows
        .filter((row) => row?.[field])
        .map((row) => {
            const value = row[field];

            return {
                value,
                label: value,
                contactPerson: row.contactPerson,
                contactEmail: row.contactEmail,
                contactNumber: row.contactNumber,
                contactPersonExtension: row.contactPersonExtension
            };
        })
        .filter((option) => {
            const key = option.value.toLowerCase();
            if (seenValues.has(key)) {
                return false;
            }
            seenValues.add(key);
            return true;
        });
};

export const filterYardContactOption = (inputValue, option = {}) => {
    const searchText = normalizeYardContactValue(inputValue).toLowerCase();
    const optionText = [
        option.value,
        option.label,
        option.contactPerson,
        option.contactEmail,
        option.contactNumber,
        option.contactPersonExtension
    ].map(normalizeYardContactValue).join(' ').toLowerCase();

    return optionText.includes(searchText);
};
